// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","MainContainer":"App_MainContainer__2-XT3","ChatContainer":"App_ChatContainer__1EegA"};